import { openBackdropWithDataInventory } from "../../../slice/sellerHub/sellerhubSlice";
import { useDispatch } from "react-redux";

const TableRow = ({ data, index }) => {
  const dispatch = useDispatch();
  const { itemId, name, availabilityStatus, itemStatus } = data;
  return (
    <div
      className={`h-12   ${
        (index + 1) % 2 !== 0 ? "bg-[#F7F9FE]" : "bg-white"
      } pl-2 flex gap-5 items-center font-Lato font-semibold text-base text-[#1E1E1E] cursor-pointer`}
      onClick={() => dispatch(openBackdropWithDataInventory(data))}
    >
      <input
        type="checkbox"
        className="w-5 h-5 outline-none border-[0.5px] border-[#DEE2F3] focus:outline-none"
      />

      <div className="w-[74px]">{index}</div>
      <div className="w-[150px] xl:w-[225px]">{itemId}</div>
      <div className="w-[150px] xl:w-[225px]">{name}</div>
      <div className="w-[150px] xl:w-[160px]">
        <div
          className={`rounded-[200px] flex justify-center items-center gap-2 ${
            availabilityStatus === "Not available"
              ? "bg-[#FFD7D8] text-[#A91F24] w-[143px]"
              : "bg-[#E7FFF0] text-[#02A443] w-[103px]"
          }`}
        >
          <p>{availabilityStatus}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chevron-down"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
      </div>
      <div
        className={`w-[93px] flex justify-center gap-2 items-center text-center rounded-[200px] h-[25px] ${
          itemStatus === "In cart"
            ? "bg-[#F0EDFF] text-[#7B61FF]"
            : "bg-[#FFD2D4] text-red-300"
        }`}
      >
        <p>{itemStatus}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-chevron-down"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
          />
        </svg>
      </div>
    </div>
  );
};

export default TableRow;
